import * as React from 'react'

import { createRoot } from 'react-dom/client'
import 'react-responsive-carousel/lib/styles/carousel.min.css'
import { BrowserRouter } from 'react-router-dom'
import { RecoilRoot } from 'recoil'
import 'reset-css'

import './misc/styles/global.module.scss'
import './misc/styles/icons/icomoon.scss'
import { Router } from './router'
import { AppContextProvider } from './ui/_functional/AppContextProvider'
import { GlobalHooks } from './ui/_functional/GlobalHooks'
import { MenuContextProvider } from './ui/_functional/MenuContextProvider'
import { SWRConfigProvider } from './ui/_functional/SWRConfigProvider'
import { Grid } from './ui/_layout/Grid'

const domNode = document.getElementById('root')
const root = createRoot(domNode as HTMLElement)

root.render(
  <RecoilRoot>
    <SWRConfigProvider>
      <AppContextProvider>
        <MenuContextProvider>
          <BrowserRouter>
            <Grid>
              <GlobalHooks />
              <Router />
            </Grid>
          </BrowserRouter>
        </MenuContextProvider>
      </AppContextProvider>
    </SWRConfigProvider>
  </RecoilRoot>
)
